<template>
  <div>
    <div>
      <router-link class="btn btn-info m-2" :to="`/dashboard/view-users`">
        Back to Administrators
      </router-link>
      <button
        class="btn btn-info m-2"
        @click="doDisable"
        v-if="user.disabled === false"
      >
        Disable User
      </button>
      <button
        class="btn btn-info m-2"
        @click="doEnable"
        v-if="user.disabled === true"
      >
        Enable User
      </button>
      <router-link
        v-if="user.merchantId"
        class="btn btn-info m-2"
        :to="`/dashboard/merchant/${user.merchantId}/agents`"
      >
        Back to Agents
      </router-link>
    </div>
    <card class="card">
      <div>
        <form @submit.prevent>
          <h3>User Information</h3>
          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="First Name"
                placeholder="First Name"
                v-model="user.firstName"
                :disabled="true"
              ></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Last Name"
                placeholder="Last Name"
                v-model="user.lastName"
                :disabled="true"
              ></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Email"
                placeholder="Email"
                v-model="user.email"
                :disabled="true"
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Company Name"
                placeholder="Company Name"
                v-model="user.companyName"
                :disabled="true"
              ></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="number"
                label="Phone Number"
                placeholder="Phone Number"
                v-model="user.phoneNumber"
                :disabled="true"
              ></fg-input>
            </div>
          </div>

          <h3>Assign Role</h3>
          <div class="row">
            <div class="col-md-4">
              <label>User Type</label>
              <select class="form-control" v-model="user.userType">
                <option value="super-admin">Super Admin</option>
                <option value="role-based">Role Based</option>
              </select>
            </div>
            <div class="col-md-8">
              <div v-if="user.userType === 'role-based'">
                <label>Role</label>
                <select class="form-control" v-model="user.roleId">
                  <option
                    :value="role._id"
                    v-for="role in roles"
                    :key="role._id"
                  >
                    {{ role.role }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="text-center mt-3">
            <p-button type="info" round @click.native.prevent="doRole">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Update Role
            </p-button>
          </div>

          <h3>Change User Password</h3>
          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="password"
                label="New Password"
                placeholder="New Password"
                v-model="password"
              ></fg-input>
            </div>
          </div>

          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Change Password
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";

export default {
  data() {
    return {
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        companyName: "",
        roleId: "",
        userType: "super-admin",
      },
      password: "",
      roles: [],
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
  },
  mounted() {
    this.getUser();
    this.getRoles();
  },
  methods: {
    ...mapActions([
      "adminChangeUserPassword",
      "setNotification",
      "enableUser",
      "disableUser",
      "updateRole",
    ]),
    async submit() {
      try {
        await this.$confirm("Change Password?");
        await this.adminChangeUserPassword({
          id: this.$route.params.userId,
          password: this.password,
        });
        this.setNotification({
          type: "success",
          message: "Password changed successfully",
        });
      } catch (error) {
        console.error(error);
        this.setNotification({
          type: "danger",
          message: "Failed to change password",
        });
      }
    },
    async doRole() {
      try {
        await this.$confirm("Change User Role?");
        if (this.user.userType === "role-based") {
          await this.updateRole({
            id: this.user._id,
            roleId: this.user.roleId,
            userType: this.user.userType,
          });
        } else {
          await this.updateRole({
            id: this.user._id,
            userType: this.user.userType,
          });
        }
        this.setNotification({
          type: "success",
          message: "Role updated successfully",
        });
      } catch (error) {
        console.error(error);
        this.setNotification({
          type: "danger",
          message: "Failed to update role",
        });
      }
    },
    async doDisable() {
      try {
        await this.$confirm("Disable User! Are you sure?");
        await this.disableUser({ id: this.user._id });
        this.getUser();
        this.setNotification({
          type: "success",
          message: "User disabled successfully",
        });
      } catch (error) {
        console.error(error);
        this.setNotification({
          type: "danger",
          message: "Failed to disable user",
        });
      }
    },
    async doEnable() {
      try {
        await this.$confirm("Enable User? Are you sure?");
        await this.enableUser({ id: this.user._id });
        this.getUser();
        this.setNotification({
          type: "success",
          message: "User enabled successfully",
        });
      } catch (error) {
        console.error(error);
        this.setNotification({
          type: "danger",
          message: "Failed to enable user",
        });
      }
    },
    async getUser() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/user/${this.$route.params.userId}`,
        );
        this.user = res.data.user;
      } catch (err) {
        console.error(err);
        this.setNotification({
          type: "danger",
          message: "Unable to Fetch User Data",
        });
      }
    },
    async getRoles() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/role`);
        this.roles = res.data.roles;
      } catch (err) {
        console.error(err);
        this.setNotification({
          type: "danger",
          message: "Unable to Fetch Roles",
        });
      }
    },
  },
};
</script>

<style scoped>
/* Add any specific styles here */
</style>
